module.exports = __webpack_public_path__ + "img/nenad_brkic.d7277139.jpg";